import { Injectable, WritableSignal } from '@angular/core';
import Map from '@arcgis/core/Map';
import { store } from '../../../../jmkw.store';
import { DEFAULT_MAP_PROPERTIES } from '../../DEFAULT_MAP_PROPERTIES';
import { JepMapProperties } from '@jeppesen-foreflight/jmkw-types';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  $map: WritableSignal<Map>;

  constructor() {
    this.$map = this.init();
  }

  init(): WritableSignal<Map> {
    store.map.set(this._createMap(DEFAULT_MAP_PROPERTIES));
    return store.map;
  }

  private _createMap(mapProperties: JepMapProperties): Map {
    return new Map(mapProperties);
  }
}
